/* ZDataTable
****************************************
OBSOLETO
NON PORTARE AVANTI QUESTA LIBRERIA. PASSARE ALLA VERSIONE 2
***********************************************************
Versione 1.25.9  23 Gennaio 2026 - Federico Migliazzi
                  - NEW: Implementati i memo
                  - NEW: Implementati gli allegati
Versione 1.24.9 - 23 Maggio 2024 - Enrico Mazzoleni 
                  - NEW: Aggiunta la possibilità di visualizzare il typButton anche quando non è presente un valore
Versione 1.23.9 - 18 Dicembre 2024 - Massimiliano Zirilli 
                  - NEW: Aggiunta funzione GetBottoneNascosto per gestire la visibilità dei campi di tipo typbutton
Versione 1.23.8 - 6 Novembre 2024 - Mauro Brasile
                  - NEW: Aggiunto "CampoDaPassareComeParametro", il campo da passare come parametro al bottone presente nella data table 
Versione 1.22.8 - 30 Settembre 2024 - Enrico Mazzoleni
                  - NEW: Aggiunto il tipo di colonna Milionesimi per le query delle coordinate GPS
Versione 1.21.8 - 18 Settembre 2024 - Massimiliano Zirilli
                  - NEW: Aggiunto il valore che indica quando una colonna di select non è valida per il calcolo del necessario
Versione 1.20.8 - 06 Agosto 2024 - Mauro Brasile
                  - NEW: aggiunta variabile alla colonna (IsDisabledWhen)
Versione 1.19.8 - 06 Giugno 2024 - Massimiliano Zirilli
                  - NEW: Aggiunta tipologia colori
Versione 1.18.8 - 29 Maggio 2024 - Dario Scianna
                  - NEW: Aggiunti campi per rendere visibile ricerca e tasto di aggiunta
Versione 1.17.8 - 28 Maggio 2024 - Mauro Brasile
                  - NEW: Aggiunta la proprietà Nascosta alla colonna
Versione 1.16.8 - 22 Marzo 2024 - Mauro Brasile
                  - NEW: Aggiunto il campo DefaultSelect per far uscire in grafica il valore di default nella typSelect
Versione 1.15.8 - 1 Febbraio 2024 - Mauro Brasile
                  - NEW: Aggiunta la prepare alle stringhe
Versione 1.14.8 - 30 Gennaio 2024 - Mauro Brasile
                  - NEW: Aggiunto il booleano RegistraCampoCalcolato: da la possibilità di registrare un campo calcolato
                         e corretta gestione del calcolo del valore
                  - NEW: Il campo nella creazione della tabella viene caricato anche per i campi calcolati senza alcuna prepare
                  - NEW: Aggiunto campo RowReadOnly nelle righe
                  - CHG: Nella creazione di una righe, se c'è un campo calcolato inserisce il valore di default
                  - FIX: Cambiato nome ZFormatDateTime nella giusta funzione FormatDateTime
Versione 1.13.7 - 21 Novembre 2023 - Mauro Brasile
                  - NEW: Aggiunto il booleano AggiungiRigaInAlto che da la possibilità di aggiungere una riga in basso o in alto
Versione 1.12.7 - 20 Novembre 2023 - Massimiliano Zirilli
                  - NEW: Aggiunta la possibilità di inserire una procedura di registrazione del valore di un campo calcolato 
Versione 1.11.7 - 28 Settembre 2023 Mauro Brasile
                  - FIX: Migliorata la GetCopy nella TZTableRow, 
                         non copiava gli oggetti all'interno della row 
Versione 1.11.6 - 28 Settembre 2023 Mauro Brasile
                  - NEW: Aggiunta la proprietà AddRowCopy nella TZDataTable 
                  - NEW: Aggiunta la proprietà GetCopy nella TZDTableRow
Versione 1.10.6 - 19 Settembre 2023 Francesco Ardini
                  - NEW: Aggiunta la proprietà "DatiEliminabili" (impostata a true di default)
                         per poter togliere la possibilità di eliminare dati dalla DataTable
Versione 1.9.6 - 06 Settembre 2023 - Massimiliano Zirilli
                 - NEW: In AssignDati posso passare ora le liste particolari per le select delle griglie
Versione 1.8.6 - 03 Agosto 2023 - Francesco Ardini
                 - NEW: Aggiunto valore di default della larghezza della tabella
                 - NEW: Aggiunta la funzione OnChange per i campi delle righe della tabella
                 - NEW: È ora possibile modificare il vettore  assegnato ad una select e mettere diversi vettori nelle select delle varie righe
Versione 1.7.6 - 14 Luglio 2023 - Brasile Mauro
                 - NEW: Aggiunto il campo Autocomplete, è possibile impostare il typSelect come una combo select o come una autocomplete
Versione 1.6.6 - 14 Giugno 2023 - Massimiliano Zirilli
                 - FIX: Piccolo errore nella funzione GetMax
Versione 1.6.5 - 7 Aprile 2022 - Mauro Brasile
                 - NEW: Aggiunto il booleano ReadOnly
                 - NEW: Aggiunto il booleano OnCalcoloValore e la proprietà CampoCalcolato
Versione 1.5.5 - 29 Marzo 2022 - Massimiliano Zirilli
                 - FIX: Nella preparazione dei parametri non gestiva il caso null per le ore
Versione 1.5.4 - 28 Marzo 2022 - Massimiliano Zirilli
                 - NEW: Aggiunto evento AfterAddRow
Versione 1.4.4 - 21 Marzo 2022 - Massimiliano Zirilli
                 - NEW: Introdotto il tipo Button
Versione 1.3.4 - 20 Marzo 2022 - Massimiliano Zirilli
                 - FIX: La gestione del valore di default delle date era sbagliata
Versione 1.3.3 - 09 Marzo 2022 - Mauro Brasile
                 - NEW: Introdotto il tipo Memo
Versione 1.2.3 - 07 Marzo 2022 - Massimiliano  Zirilli
                 - FIX: Errore nel caricare campi di tipo mese
                 - NEW: Aggiunto il campo Disabilitato
Versione 1.1.2 - 28 Febbraio 2022 - Massimiliano  Zirilli
                 - FIX: Quando assegno dati dall'esterno se non c'è la chiave considero
                        la riga come da inserire (nuova)
Versione 1.1.1 - 01 Febbraio 2022 - Massimiliano  Zirilli
                 - FIX: La proprietà che rappresenta un possibile valore nullo
                        si trova ora nella gestione della colonna
Versione 1.1.0 - 26 Gennaio 2022 - Massimiliano  Zirilli
                 - NEW: Aggiunti i tipi data
Versione 1.0.0 - 06 Agosto 2022 - Massimiliano  Zirilli
                 - Prima versione
*/
import { TZGenericFunct } from "./ZGenericFunct";
import { TZDateFunct } from './ZDateFunct'
import { TSchedaGenerica } from './ZSchedaGenerica'
var NextId = 1;

const COLOR_DEFAULT = 'rgb(0 0 0 /1)'

export const TZDTableColumnType = 
{
   typBoolean       : 1,
   typString        : 2,
   typInteger       : 3,
   typDecimi        : 4,
   typCentesimi     : 5,
   typMillesimi     : 6,
   typSelect        : 7,
   typCalcField     : 8,
   typMemo          : 9,
   typDate          : 10,
   typTime          : 11,
   typDateTime      : 12,
   typMonth         : 13,
   typButton        : 14,
   typColor         : 15,
   typMilionesimi   : 16,
   typAllegati      : 17
}

export class TZDataSingleField
{
  constructor(Tipo)
  {
    this.Tipo                = Tipo;
    this.Valore              = null;
    this.PosizioneAllegato   = null;
    this.PosAllegatoIniziale = null;
    this.FileBase64          = null;
  }
}

export class TZDTableRow 
{
   constructor(Nuovo,Configurazione,OnRowChange)
   {
     this.Dati           = {}
     this.Liste          = {}
     this.Graphics       = {}
     this.Nuovo          = Nuovo;
     this.Eliminato      = false;
     this.ErroreDoppione = false;
     this.Configurazione = Configurazione;
     this.RowReadOnly    = false;
     this.IdRiga         = NextId++;
     this.OnChange       = OnRowChange;
   }

   GetBottoneNascosto(Valore)
   {
      return Valore != null
   }

   GetCopy()
   {
      var Elemento = new TZDTableRow()
      for(var k in this) 
      {
         if(typeof this[k] === 'object' || Array.isArray(this[k]))
            Elemento[k] = JSON.parse(JSON.stringify(this[k]))
         else Elemento[k] = this[k];
      }
      return Elemento;
   }

   GetText(Campo)
   {
     var AColonna = this.Configurazione.GetColumn(Campo);
     var Self = this;
     if(AColonna != undefined)
     {
       switch(AColonna.Tipo)
       {
         case TZDTableColumnType.typString    :
         case TZDTableColumnType.typMemo      :
         case TZDTableColumnType.typDate      :
         case TZDTableColumnType.typMonth     :
         case TZDTableColumnType.typButton    : 
         case TZDTableColumnType.typDateTime  :
         case TZDTableColumnType.typColor     :
         case TZDTableColumnType.typTime      : return this.Dati[AColonna.Campo].Valore.trim()
                                                break;
         case TZDTableColumnType.typSelect    : if(AColonna.Lista != undefined)
                                                {
                                                   let SelectOption = AColonna.Lista.find(function(Elemento)
                                                   {
                                                      return Elemento[AColonna.SelCampoChiave] == Self.Dati[AColonna.Campo].Valore 
                                                   });
                                                   if(SelectOption != undefined)
                                                      return SelectOption[AColonna.SelCampoCaption] == undefined ? '' : SelectOption[AColonna.SelCampoCaption];
                                                   else return '';
                                                }
                                                break;
         case TZDTableColumnType.typInteger   :
         case TZDTableColumnType.typDecimi    :
         case TZDTableColumnType.typCentesimi : 
         case TZDTableColumnType.typMilionesimi :
         case TZDTableColumnType.typMillesimi : if(Self.Dati[AColonna.Campo].Valore == '')
                                                   return '0'
                                                else return this.Dati[AColonna.Campo].Valore + '';
                                                break;

         case TZDTableColumnType.typAllegati  : return Self.Dati[AColonna.Campo].PosizioneAllegato;
       }
     } 
     else console.error('GetText: Colonna sconosciuta');
     return '';
   }

   GetColumn(Campo)
   {
     return this.Configurazione.GetColumn(Campo) 
   }

   IsString(Campo)
   {
     return(this.Dati[Campo].Tipo == TZDTableColumnType.typString);
   }

   IsMemo(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typMemo);
   }

   IsBoolean(Campo)
   {
     return(this.Dati[Campo].Tipo == TZDTableColumnType.typBoolean);
   }

   IsSelect(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typSelect);
   }

   IsNumber(Campo)
   {
      return([TZDTableColumnType.typInteger,
              TZDTableColumnType.typCentesimi,
              TZDTableColumnType.typDecimi,
              TZDTableColumnType.typMillesimi,
              TZDTableColumnType.typMilionesimi].includes(this.Dati[Campo].Tipo))
   }

   IsDateTime(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typDateTime);
   }

   IsMonth(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typMonth);
   }

   IsAButton(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typButton);
   }

   IsDate(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typDate);
   }

   IsColor(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typColor);
   }

   IsTime(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typTime);
   }

   IsAllegato(Campo)
   {
      return(this.Dati[Campo].Tipo == TZDTableColumnType.typAllegati);
   }


   StepNumber(Campo)
   {
     switch(Campo)
     {
        case TZDTableColumnType.typDecimi      : return('0.1');
        case TZDTableColumnType.typCentesimi   : return('0.01');
        case TZDTableColumnType.typMillesimi   : return('0.001');
        case TZDTableColumnType.typMilionesimi : return('0.000001');
        default                                : return('1');
     }
   }

   CampoInserito(Campo)
   {
     var Colonna = this.Configurazione.GetColumn(Campo);
     if(Colonna != undefined)
     {
       return this.__CampoInserito(Colonna)
     }
     else console.error('CampoInserito: Colonna non trovata')
     return false
   }

   __CampoInserito(AColonna)
   {
       switch(AColonna.Tipo)
       {
         case TZDTableColumnType.typString    :
         case TZDTableColumnType.typMemo      :
         case TZDTableColumnType.typDate      :
         case TZDTableColumnType.typMonth     :
         case TZDTableColumnType.typColor     :
         case TZDTableColumnType.typDateTime  :
         case TZDTableColumnType.typTime      : if(this.Dati[AColonna.Campo].Valore.trim() == '')
                                                   return false
                                                break;
         case TZDTableColumnType.typButton    : return true;
                                                break;
         case TZDTableColumnType.typSelect    : if(this.Dati[AColonna.Campo].Valore == AColonna.CampoSelectNonValido)
                                                   return false;
                                                break;
         case TZDTableColumnType.typInteger   :
         case TZDTableColumnType.typDecimi    :
         case TZDTableColumnType.typCentesimi : 
         case TZDTableColumnType.typMilionesimi :
         case TZDTableColumnType.typMillesimi : if(parseFloat(this.Dati[AColonna.Campo].Valore) == 0 || this.Dati[AColonna.Campo].Valore == '')
                                                   return false;
                                                break;

         case TZDTableColumnType.typAllegati  : if(this.Dati[AColonna.Campo].PosizioneAllegato == '')
                                                   return false;
        }
       return true;
   }

   AllDataOk()
   {
     return this.RowErrors().length == 0;
   } 

   RowErrors()
   {
       var Result = [];
       var Self = this;
       var CampiDoppione = '';
       this.Configurazione.Colonne.forEach(function(AColonna)
       {
          if(!AColonna.DoppioniPermessi)
             CampiDoppione += AColonna.Titolo + ';';
          if(AColonna.Necessario)
             if(!Self.__CampoInserito(AColonna))
                Result.push('Inserire ' + AColonna.Titolo.toLowerCase());

       });
       if(Self.ErroreDoppione && CampiDoppione != '')
          Result.push('I seguenti campi non possono essere ripetuti [' + CampiDoppione + ']');
       return Result;
  }

  Snapshot()
  {
     this.StartData = JSON.stringify(this.Dati);
  }

  Modificato()
  {
     return this.Eliminato || this.Nuovo || JSON.stringify(this.Dati) != this.StartData;
  }
}

export class TZDTableColumn
{
  constructor(Id,Titolo,Tipo,Campo,Larghezza)
  {
     this.Id                     = Id;
     this.Tipo                   = Tipo;
     this.Titolo                 = Titolo;
     this.Campo                  = Campo;
     this.Larghezza              = Larghezza;
     this.Ordinamento            = false;
     this.Necessario             = false;
     this.OnCalcoloValore        = null;
     this.ShowTitle              = true;
     this.Progressivo            = false;
     this.Disabilitato           = false;
     this.DefaultSelect          = false;
     this.Autocomplete           = false;
     this.ReadOnly               = false;
     this.BoolEsclusivo          = false;
     this.Lista                  = [];
     this.DefaultValue           = null;
     this.DoppioniPermessi       = true;
     this.RegistraCampoCalcolato = false;
     this.ValueNullForSelect     = "-1";
     this.SelCampoChiave         = 'CHIAVE'
     this.SelCampoCaption        = 'DESCRIZIONE'

     // CAMPI PER TYPBUTTON
     this.ValueNullForButton          = null;
     this.ButtonContent               = 'Pulsante'
     this.ButtonContentIsImage        = false;
     this.ButtonContentDefault        = null;
     this.CampoDaPassareComeParametro = null;
     
     this.Nascosta               = false;
     this.IsDisabledWhen         = null;
     this.CampoSelectNonValido   = null;
     this.FunctionOnChangeValore = null;
  }

  CampoCalcolato()
  {
     return this.OnCalcoloValore != null;
  }

  GetTitleAlignment()
  {
    switch(this.Tipo)
    {
       case TZDTableColumnType.typBoolean      : 
       case TZDTableColumnType.typCentesimi    :
       case TZDTableColumnType.typMillesimi    :
       case TZDTableColumnType.typDecimi       :
       case TZDTableColumnType.typMilionesimi  : 
       case TZDTableColumnType.typInteger      :
       case TZDTableColumnType.typAllegati     : return "center";
       default                                 : return "left";
    }
  }
}

class TZDataTableCfg 
{
   constructor(CampoChiave)
   {
      this.CampoChiave = CampoChiave;
      this.Larghezza = '100%'
      this.ClearColumns();
   }

   GetColumn(Campo)
   {
     return this.Colonne.find(function(AColonna)
     {
       return AColonna.Campo == Campo;
     })
   }

   ClearColumns()
   {
     this.Colonne = []
   }

   AddColumn(Titolo,Tipo,Campo,Larghezza)
   {
     var ANewColumn = new TZDTableColumn(NextId++,Titolo,Tipo,Campo,Larghezza);
     this.Colonne.push(ANewColumn);
     return ANewColumn;
   }
}

export class TZDataTable
{
   constructor(CampoChiave)
   {
      this.Configurazione        = new TZDataTableCfg(CampoChiave);
      this.Righe                 = [];
      this.PaddingBottom         = null;
      this.DatiEliminabili       = true
      this.AggiungiRigaInAlto    = true;
      this.TastoAggiungiVisibile = true
      this.EditRicercaVisibile   = true
      this.LarghezzaColonneRestantiInPixels = 0;
      this.OrdinatoPer    = {
                               Campo :  '',
                               Discendente : false
                            };
      this.OnRowChange = function() { };
      console.group('ZDataTable: DEPRECATA')
      console.log('UTILIZZARE INVECE ZDataTable2')
      console.log('LIBRERIA NON RETROCOMPATIBILE')
      console.log('---> VA ADEGUATA LA GESTIONE DELL\'EVENTO OnChange da sostiruire con l\'evento OnRowChange')
      console.log('L\'evento OnRowChange deve essere assegnato al mounted dei componenti')
      console.log('Prendere per esempio di come gestire la scheda generica e le configurazioni generiche da Puente')
      console.groupEnd()

   }

  //  OnLoadAllegato = function(Row,Colonna,OnSuccess)
  //  {
  //     console.error('OnLoadAllegato non implementata')
  //  }

   AllDataOk()
   {
     for(let i = 0; i < this.Righe.length; i++)
        if(!this.Righe[i].AllDataOk())
          return false;
     return true;
   } 

   ClearColumns()
   {
     this.Configurazione.ClearColumns()
   }

   AddColumn(Titolo,Tipo,Campo,Larghezza)
   {
     return this.Configurazione.AddColumn(Titolo,Tipo,Campo,Larghezza)
   }

   GetColumn(Campo)
   {
     return this.Configurazione.GetColumn(Campo)
   }

   Modificato()
   {
     for(let i = 0; i < this.Righe.length; i++)
        if(this.Righe[i].Modificato())
          return true;
     return false;
   }

   OrdinaPer(Campo,OrdineDiscendente = false)
   {
     var GetValoreConfronto = function(Riga,Campo)
     {
        let Colonna = Riga.Configurazione.GetColumn(Campo)
        if(Colonna.CampoCalcolato())
          return GetValoreCampoCalcolato(Riga,Colonna)
        if(Riga.IsString(Campo))
          return Riga.Dati[Campo].Valore.toUpperCase();
        if(Riga.IsNumber(Campo))
          return parseFloat(Riga.Dati[Campo].Valore);
        if(Riga.IsSelect(Campo))
        {
          if(Colonna != undefined)
          {
            let SelectOption = Colonna.Lista.find(function(Option)
            {
               return Option[Colonna.SelCampoChiave] == Riga.Dati[Campo].Valore;
            })
            if(SelectOption != undefined) 
            {
               if(SelectOption[Colonna.SelCampoCaption] != undefined)
                  return SelectOption[Colonna.SelCampoCaption].toUpperCase();
               else
               {
                 console.error('OrdinaPer: Campo descrizione sbagliato')
               }
            }
          }
        }
        return Riga.Dati[Campo].Valore
     }
     
     this.Righe.sort(function(Riga1,Riga2)
     {
        if(TZGenericFunct.XOR(Riga1.Nuovo,Riga2.Nuovo)) 
           return Riga1.Nuovo ? -1 : 1;

        let Confronto1 = GetValoreConfronto(Riga1,Campo);
        let Confronto2 = GetValoreConfronto(Riga2,Campo);
        if(Confronto1 > Confronto2)
          return OrdineDiscendente ? -1 : 1;
        if(Confronto1 < Confronto2)
          return OrdineDiscendente ? 1 : -1;
        return 0;
     });
     this.OrdinatoPer.Campo       = Campo;
     this.OrdinatoPer.Discendente = OrdineDiscendente;
   }

   GetValoreCampoCalcolato(Riga,Colonna)
   {
     if(Colonna.OnCalcoloValore instanceof Function)
        return Colonna.OnCalcoloValore(Riga.Dati,Colonna)
     if(Colonna.OnCalcoloValore === '$Index')
       for(let i = 0; i < this.Righe.length; i++)
          if(this.Righe[i] == Riga)
             return i + ''
     return '????'
   }

   ResetBoolExceptFor(Riga,Campo)
   {
     this.Righe.forEach(function(ARiga)
     {
       if(ARiga != Riga)
          ARiga.Dati[Campo].Valore = false;
     })
   }

   DeleteAllRows()
   {
      var i = 0;
      while(i < this.Righe.length)
      {
        if(!this.DeleteRow(this.Righe[i]))
           i++
      }
   }

   DeleteRow(Riga)
   {
     if(!Riga.Nuovo)
        Riga.Eliminato = true;
     else
     {
       this.Righe = this.Righe.filter(function(Elemento)
       {
         return Elemento != Riga;
       });   
       return true;
     }
     return false
   }

   GetMax(Campo)
   {
     var Result = null;
     this.Righe.forEach(function(SingolaRiga)
     {
       if(Result == null || Result < parseInt(SingolaRiga.Dati[Campo].Valore))
          Result = parseInt(SingolaRiga.Dati[Campo].Valore) 
     });
     return Result;

   }

   AddRowsOnTop(NrRighe)
   {
     var FirstRow = undefined; 
     for(let i = 0; i < NrRighe; i++)
     {
        var ANewRow = new TZDTableRow(true,this.Configurazione,this.OnRowChange);
        if(FirstRow == undefined)
           FirstRow = ANewRow;
        var Self = this;
        Self.Configurazione.Colonne.forEach(function(AColonna)
        {
           ANewRow.Dati[AColonna.Campo] = new TZDataSingleField(AColonna.Tipo);
           ANewRow.Graphics[AColonna.Campo] = {}
           if(AColonna.Tipo == TZDTableColumnType.typButton)
           {
             ANewRow.Graphics[AColonna.Campo].ButtonContent        = AColonna.ButtonContent;
             ANewRow.Graphics[AColonna.Campo].ButtonContentIsImage = AColonna.ButtonContentIsImage;
             ANewRow.Graphics[AColonna.Campo].ButtonContentDefault        = AColonna.ButtonContentDefault;
             ANewRow.Graphics[AColonna.Campo].CampoDaPassareComeParametro = AColonna.CampoDaPassareComeParametro;
           }

           if(!AColonna.CampoCalcolato())
           {
               if(AColonna.DefaultValue != null)
               {
                  switch(AColonna.Tipo)
                  {
                        case TZDTableColumnType.typDate      : ANewRow.Dati[AColonna.Campo].Valore = TZDateFunct.DateInHTMLInputFormat(AColonna.DefaultValue);
                                                               break
                        case TZDTableColumnType.typTime      : ANewRow.Dati[AColonna.Campo].Valore = TZDateFunct.FormatDateTime('hh:nn',AColonna.DefaultValue);
                                                               break
                        case TZDTableColumnType.typDateTime  : ANewRow.Dati[AColonna.Campo].Valore = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn',AColonna.DefaultValue);
                                                               break;
                        default                              : ANewRow.Dati[AColonna.Campo].Valore = AColonna.DefaultValue
                                                               break;
                  }
               }
               else
               {
                  switch(AColonna.Tipo)
                  {
                     case TZDTableColumnType.typBoolean     : ANewRow.Dati[AColonna.Campo].Valore = false;
                                                              break;
                     case TZDTableColumnType.typString      : 
                     case TZDTableColumnType.typMemo        : 
                     case TZDTableColumnType.typDate        :
                     case TZDTableColumnType.typTime        : 
                     case TZDTableColumnType.typMonth       :
                     case TZDTableColumnType.typDateTime    : ANewRow.Dati[AColonna.Campo].Valore = '';
                                                              break;
                     case TZDTableColumnType.typColor       : ANewRow.Dati[AColonna.Campo].Valore = COLOR_DEFAULT
                                                              break; 
                     case TZDTableColumnType.typSelect      : AColonna.Autocomplete? 
                                                              ANewRow.Dati[AColonna.Campo].Valore = -1 : 
                                                              ANewRow.Dati[AColonna.Campo].Valore = null;
                                                              break;
                     case TZDTableColumnType.typInteger     : if(AColonna.Progressivo) 
                                                              {  
                                                                 ANewRow.Dati[AColonna.Campo].Valore = Self.GetMax(AColonna.Campo)
                                                                 if(ANewRow.Dati[AColonna.Campo].Valore == null)
                                                                    ANewRow.Dati[AColonna.Campo].Valore = 1
                                                                 else ANewRow.Dati[AColonna.Campo].Valore += 1
                                                              }
                                                              else ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                              break;
                     case TZDTableColumnType.typDecimi      :
                     case TZDTableColumnType.typCentesimi   : 
                     case TZDTableColumnType.typMilionesimi :
                     case TZDTableColumnType.typMillesimi   : ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                              break;
                     case TZDTableColumnType.typAllegati    : break;
                                                              // ANewRow.Dati[AColonna.Campo].Valore = null;
                  }
               }
           }
           else
           {
               if(AColonna.DefaultValue != null)
               {
                  ANewRow.Dati[AColonna.Campo].Valore = AColonna.DefaultValue;
               }
           }
        });
        ANewRow.OnChange('*');
        //qui è possibile mettere la riga in alto o in basso
        if(Self.AggiungiRigaInAlto)
           Self.Righe.unshift(ANewRow);
        else Self.Righe.push(ANewRow)
        if(Self.AfterAddRow != undefined)
           Self.AfterAddRow(ANewRow);
     }
     return FirstRow;
   }

   PrepareQueryParameters(Riga)
   {
      let Self = this
      var Result = {};
      this.Configurazione.Colonne.forEach(function(AColonna)
      {
           if(AColonna.CampoCalcolato())
           {
               if(AColonna.RegistraCampoCalcolato)
                  Riga.Dati[AColonna.Campo].Valore = Self.GetValoreCampoCalcolato(Riga,AColonna) 
           }
           else
           {
              switch(AColonna.Tipo)
              {
                case TZDTableColumnType.typMonth        : if(Riga.Dati[AColonna.Campo].Valore != undefined &&
                                                            Riga.Dati[AColonna.Campo].Valore != null &&
                                                            Riga.Dati[AColonna.Campo].Valore.length == 7)
                                                          {
                                                            Result[AColonna.Campo] = parseInt(Riga.Dati[AColonna.Campo].Valore.substring(0,4) + 
                                                                                              Riga.Dati[AColonna.Campo].Valore.substring(5,7))
                                                            if(Result[AColonna.Campo] == 0) 
                                                                Result[AColonna.Campo] = null;
                                                          }
                                                          else Result[AColonna.Campo] = null;
                                                          break;

                case TZDTableColumnType.typButton       : if(Riga.Dati[AColonna.Campo].Valore == AColonna.ValueNullForButton)  
                                                            Result[AColonna.Campo] = null;
                                                          else Result[AColonna.Campo] = Riga.Dati[AColonna.Campo].Valore
                                                          break;  

                case TZDTableColumnType.typBoolean      : Result[AColonna.Campo] = Riga.Dati[AColonna.Campo].Valore ? 'T' : 'F';
                                                          break;

                case TZDTableColumnType.typString       : 
                case TZDTableColumnType.typMemo         : 

                case TZDTableColumnType.typColor        : if(Riga.Dati[AColonna.Campo].Valore == undefined || Riga.Dati[AColonna.Campo].Valore == null) 
                                                              Riga.Dati[AColonna.Campo].Valore = '';
                                                          Result[AColonna.Campo] = TSchedaGenerica.PrepareForRecordString(Riga.Dati[AColonna.Campo].Valore);
                                                          break;

                case TZDTableColumnType.typDate         :
                case TZDTableColumnType.typDateTime     :

                case TZDTableColumnType.typTime         : if(Riga.Dati[AColonna.Campo].Valore != '') 
                                                            Result[AColonna.Campo] = TSchedaGenerica.PrepareForRecordString(Riga.Dati[AColonna.Campo].Valore);
                                                          else Result[AColonna.Campo] = null
                                                          break;

                case TZDTableColumnType.typSelect       : if(Riga.Dati[AColonna.Campo].Valore == AColonna.ValueNullForSelect)  
                                                            Result[AColonna.Campo] = null;
                                                          else Result[AColonna.Campo] =  Riga.Dati[AColonna.Campo].Valore
                                                          break;  

                case TZDTableColumnType.typInteger      : Result[AColonna.Campo] = parseInt(Riga.Dati[AColonna.Campo].Valore);
                                                          break;

                case TZDTableColumnType.typDecimi       : Result[AColonna.Campo] = Math.round(Riga.Dati[AColonna.Campo].Valore * 10);
                                                          break;

                case TZDTableColumnType.typCentesimi    : Result[AColonna.Campo] = Math.round(Riga.Dati[AColonna.Campo].Valore * 100);
                                                          break;

                case TZDTableColumnType.typMillesimi    : Result[AColonna.Campo] = Math.round(Riga.Dati[AColonna.Campo].Valore * 1000);
                                                          break;

                case TZDTableColumnType.typMilionesimi  : Result[AColonna.Campo] = Math.round(Riga.Dati[AColonna.Campo].Valore * 1000000);
                                                          break;

                case TZDTableColumnType.typAllegati     : Result[AColonna.Campo] = Riga.Dati[AColonna.Campo].PosizioneAllegato;
                                                          break;
              }
           }
      });
      Result[this.Configurazione.CampoChiave] = Riga.Dati[this.Configurazione.CampoChiave];
      return Result;
   }

   Clear()
   {
     this.AssignDati([])
   }

   AssignDati(DatiEsterni,NonAzzerareVettore)
   {
     var Self = this;
     var CampoOrdinamento = '';
     if(NonAzzerareVettore == undefined)
         Self.Righe = [];
   
     DatiEsterni.forEach(function(ARigaEsterna)
     {
        var NuovaRiga = ARigaEsterna[Self.Configurazione.CampoChiave] == undefined ||
                        ARigaEsterna[Self.Configurazione.CampoChiave] == -1
        var ANewRow = new TZDTableRow(NuovaRiga,Self.Configurazione,Self.OnRowChange);
        Self.Configurazione.Colonne.forEach(function(AColonna)
        {
           if(AColonna.Ordinamento && CampoOrdinamento == '')
              CampoOrdinamento = AColonna.Campo;
               
           ANewRow.Dati[AColonna.Campo] = new TZDataSingleField(AColonna.Tipo);
           ANewRow.Graphics[AColonna.Campo] = {}
           if(!AColonna.CampoCalcolato())
           {
              switch(AColonna.Tipo)
              {
                    case TZDTableColumnType.typButton        : ANewRow.Graphics[AColonna.Campo].ButtonContent = AColonna.ButtonContent;
                                                              ANewRow.Graphics[AColonna.Campo].ButtonContentIsImage = AColonna.ButtonContentIsImage;
                                                              ANewRow.Graphics[AColonna.Campo].ButtonContentDefault = AColonna.ButtonContentDefault;
                                                              ANewRow.Graphics[AColonna.Campo].CampoDaPassareComeParametro = AColonna.CampoDaPassareComeParametro;
                                                              if(AColonna.Campo != null && AColonna.Campo != '')
                                                                  ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] 
                                                              break

                    case TZDTableColumnType.typMonth         : if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                ANewRow.Dati[AColonna.Campo].Valore = ''
                                                              else 
                                                              {
                                                                ARigaEsterna[AColonna.Campo] += '' 
                                                                if(ARigaEsterna[AColonna.Campo].length != 6)
                                                                ANewRow.Dati[AColonna.Campo].Valore = ''
                                                                else 
                                                                {
                                                                    let ValoreDBase = parseInt(ARigaEsterna[AColonna.Campo])
                                                                    let Anno = Math.trunc(ValoreDBase / 100)
                                                                    let Mese = ValoreDBase % 100
                                                                    ANewRow.Dati[AColonna.Campo].Valore = Anno.toString() + '-' + 
                                                                                                        (Mese < 10 ? '0' : '') + 
                                                                                                        Mese.toString()
                                                                }
                                                              }
                                                              break;

                    case TZDTableColumnType.typBoolean       : ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] == 'T';
                                                              break;

                    case TZDTableColumnType.typString        :
                    case TZDTableColumnType.typMemo          :
                    case TZDTableColumnType.typDate          :
                    case TZDTableColumnType.typColor         :
                    case TZDTableColumnType.typDateTime      :

                    case TZDTableColumnType.typTime          : if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                  ANewRow.Dati[AColonna.Campo].Valore = ''
                                                              else ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] + '';
                                                              if(ANewRow.Dati[AColonna.Campo].Valore == '' && AColonna.Tipo == TZDTableColumnType.typColor)
                                                                ANewRow.Dati[AColonna.Campo].Valore = COLOR_DEFAULT
                                                              break;

                    case TZDTableColumnType.typSelect        : if(ARigaEsterna.Liste != undefined && ARigaEsterna.Liste[AColonna.Campo] != undefined)
                                                                  ANewRow.Liste[AColonna.Campo] = ARigaEsterna.Liste[AColonna.Campo]
                                                              if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                ANewRow.Dati[AColonna.Campo].Valore = AColonna.ValueNullForSelect
                                                              else ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] + '';
                                                              break; 

                    case TZDTableColumnType.typInteger       : if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                              else ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo];
                                                              break;

                    case TZDTableColumnType.typDecimi        : if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                              else ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] / 10;
                                                              break;

                    case TZDTableColumnType.typCentesimi     : if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                              else ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] / 100;
                                                              break;

                    case TZDTableColumnType.typMillesimi     : if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                              else ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] / 1000;
                                                              break;

                    case TZDTableColumnType.typMilionesimi   : if(ARigaEsterna[AColonna.Campo] == undefined || ARigaEsterna[AColonna.Campo] == null) 
                                                                  ANewRow.Dati[AColonna.Campo].Valore = 0;
                                                              else ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo] / 1000000;
                                                              break;

                    case TZDTableColumnType.typAllegati      :  ANewRow.Dati[AColonna.Campo].PosizioneAllegato   = ARigaEsterna[AColonna.Campo];
                                                                ANewRow.Dati[AColonna.Campo].PosAllegatoIniziale = ARigaEsterna[AColonna.Campo];
                                                                ANewRow.Dati[AColonna.Campo].Valore = null;
                                                                break;
              }
           }
           else 
           {
              if(AColonna.Campo != '')
                ANewRow.Dati[AColonna.Campo].Valore = ARigaEsterna[AColonna.Campo]
           }
        });
        ANewRow.Dati[Self.Configurazione.CampoChiave] = NuovaRiga ? -1 : ARigaEsterna[Self.Configurazione.CampoChiave];
        ANewRow.Snapshot();
        ANewRow.OnChange('*')
        Self.Righe.push(ANewRow);
        if(Self.AfterAddRow != undefined)
           Self.AfterAddRow(ANewRow);
     });
     if(CampoOrdinamento != '')
        this.OrdinaPer(CampoOrdinamento)
   }

   CheckDoppioni()
   {
     var ColonneDaControllare = [];
     this.Configurazione.Colonne.forEach(function(AColonna)
     {
       if(!AColonna.DoppioniPermessi)
          ColonneDaControllare.push(AColonna);
     })   

     if(ColonneDaControllare.length > 0)
     {
        var ValoriDoppi = {};
        this.Righe.forEach(function(ARiga)
        {
           ColonneDaControllare.forEach(function(AColonna)
           {
              var GetStartObject = function(ARiga,Campo)
              {
                   return {
                             Righe  : [ARiga],
                             Valore : ARiga.Dati[Campo].Valore 
                          } 
              } 
              if(ARiga.__CampoInserito(AColonna))
              {
                 if(ValoriDoppi[AColonna.Campo] == undefined)
                    ValoriDoppi[AColonna.Campo] = [ GetStartObject(ARiga,AColonna.Campo) ]
                 else
                 {
                   var ObjValore = ValoriDoppi[AColonna.Campo].find(function(AValore)
                   {
                     return AValore.Valore == ARiga.Dati[AColonna.Campo].Valore;
                   })
                   if(ObjValore == undefined)
                      ValoriDoppi[AColonna.Campo].push(GetStartObject(ARiga,AColonna.Campo));
                   else ObjValore.Righe.push(ARiga);
                 }
              }

           });
       });
       for(var CampoInEsame in ValoriDoppi) 
       {
         ValoriDoppi[CampoInEsame].forEach(function(StatoCampoInEsame)
         {
             StatoCampoInEsame.Righe.forEach(function(SingolaRiga)
             {
               if(TZGenericFunct.XOR(SingolaRiga.ErroreDoppione,StatoCampoInEsame.Righe.length > 1))
                  SingolaRiga.ErroreDoppione = StatoCampoInEsame.Righe.length > 1;
             })
         });
        }
     }
   }

   AddRowCopy(Row, NumeroCopie)
   {
      var Result = []

      for(let i = 0; i < NumeroCopie; i++)
      {
         var Elemento = Row.GetCopy()
         Result.push(Elemento);
      }
      for(let i = 0; i < Result.length; i++)
      {
         Result[i].Nuovo = true
         this.Righe.push(Result[i])
      }
      return Result;
   }
}